import api from '../utils/api';
import { API_ROOT } from '../constants';
import { trackReferral } from '../services/track-referral';
import { getTrialAnalytics } from '../services/manage';
import { isTrialAccount } from '../utils/general';

export const FETCHING_USER = 'FETCHING_USER';
export const fetchingUser = (payload) => ({
  type: FETCHING_USER,
  payload
});

export const INSERT_USER_PROFILE = 'INSERT_USER_PROFILE';
export const insertUserProfile = (data) => ({
  type: INSERT_USER_PROFILE,
  payload: {
    ...data
  }
});

export const ACCOUNT_MODAL = 'ACCOUNT_MODAL';
export const accountModal = (show) => ({
  type: ACCOUNT_MODAL,
  payload: show
});

export const UPGRADE_MODAL = 'UPGRADE_MODAL';
export const showUpgradeModal = (show) => {
  if (show) {
    window.scrollTo(0, 0);
  }

  return {
    type: UPGRADE_MODAL,
    payload: show
  };
};

export const INSERT_TRIAL_ANALYTICS = 'INSERT_TRIAL_ANALYTICS';
export const insertTrialAnalytics = (payload) => ({
  type: INSERT_TRIAL_ANALYTICS,
  payload
});

async function fetchTrialAnalytics(dispatch, userProfile, liveSites) {
  const trialAccount = isTrialAccount(userProfile);
  if (trialAccount && liveSites.length > 0) {
    try {
      const trialAnalytics = await getTrialAnalytics(liveSites);
      dispatch(insertTrialAnalytics(trialAnalytics?.data));
    } catch (err) {
      console.error('trialAnalytics', err);
    }
  }
}

export const fetchUserData = () => (dispatch) => {
  dispatch(fetchingUser(true));
  api
    .post(`${API_ROOT}/pro/manage`)
    .then(async (res) => {
      const data = res.data;
      dispatch(fetchingUser(false));
      dispatch(insertUserProfile(data));

      const { userProfile, liveSites } = data;
      if (data.userProfile.productId && localStorage.getItem('referral')) {
        trackReferral(data.userProfile.email);
      }

      await fetchTrialAnalytics(dispatch, userProfile, liveSites);
    })
    .catch((err) => {
      console.error('fetchUserProfile', err);
      localStorage.removeItem('token');
      dispatch(fetchingUser(false));
      window.location = '/login';
    });
};

export const ACTION_PROCESSING = 'ACTION_PROCESSING';
export const actionProcessing = (payload) => ({
  type: ACTION_PROCESSING,
  payload
});

export const SHOW_MESSAGE_MODAL = 'SHOW_MESSAGE_MODAL';
export const showMessageModal = (payload) => ({
  type: SHOW_MESSAGE_MODAL,
  payload
});

export const HIDE_MESSAGE_MODAL = 'HIDE_MESSAGE_MODAL';
export const hideMessageModal = () => ({
  type: HIDE_MESSAGE_MODAL
});

export const CUSTOM_DOMAIN_MODAL = 'CUSTOM_DOMAIN_MODAL';
export const showCustomDomainModal = (payload) => ({
  type: CUSTOM_DOMAIN_MODAL,
  payload
});

export const CREATE_SITE_MODAL = 'CREATE_SITE_MODAL';
export const showCreateSiteModal = (visible, data, action) => ({
  type: CREATE_SITE_MODAL,
  payload: {
    visible,
    data,
    action
  }
});

export const DRAGGED_FILE = 'DRAGGED_FILE';
export const setDraggedFile = (file) => {
  return {
    type: DRAGGED_FILE,
    payload: file
  };
};

export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const toggleModal = (payload) => {
  return {
    type: TOGGLE_MODAL,
    payload
  };
};

export const TOGGLE_TEAM_MODAL = 'TOGGLE_TEAM_MODAL';
export const toggleTeamModal = (payload) => {
  return {
    type: TOGGLE_TEAM_MODAL,
    payload
  };
};

export const SHOW_QRCODE_MODAL = 'SHOW_QRCODE_MODAL';
export const setQrCodeModal = (payload) => {
  return {
    type: SHOW_QRCODE_MODAL,
    payload
  };
};

export const SET_QRCODE_DATA = 'SET_QRCODE_DATA';
export const setQrCodeData = (payload) => {
  return {
    type: SET_QRCODE_DATA,
    payload
  };
};
